<template>
  <div class="row">
    <div class="col-12" v-for="file in files" :key="file._id">
        <div class="card card-body" @click="$router.push(`/file/${file._id}`)" style="border-radius: 10px">
            <div class="media">
                <a class="d-flex align-self-center" href="#">
                    <img :src="require('@/assets/images/file.png')" style="width: 80px; max-width: 100%">
                </a>
                <div class="media-body align-self-center">
                    <h4>{{ file.title }}</h4>
                    <span>
                        <i class="fa fa-clock-o"></i> {{ file.create_date }}
                        <br>
                        <i class="fa fa-edit"></i> {{ file.last_update }}
                        <br>
                        <i class="fa fa-file"></i> &nbsp;
                        <span v-if="file.type == '1'">معلم</span>
                        <span v-if="file.type == '2'">معلم مسند له نشاط طلابي</span>
                        <span v-if="file.type == '3'">معلم مسند له توجيه صحي</span>
                        <span v-if="file.type == '4'">محضر مختبر</span>
                        <span v-if="file.type == '5'">معلمة رياض أطفال</span>
                        <span v-if="file.type == '6'">الوكيل والمدير</span>
                        <span v-if="file.type == '7'">الموجه الطلابي</span>
                    </span>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            user: JSON.parse(localStorage.getItem("user")),
            files: []
        }
    },
    created(){this.gett()},
    methods: {
        gett(){
            var g = this;
            $.post(api + '/user/files/list', {
                jwt: g.user.jwt,
            }).then(function(r){
                g.files = r.response
            })
        }
    }
}
</script>

<style>

</style>